export const HAS_SEARCHED = 'HAS_SEARCHED';

export const hasSearched = (value) => {
  return { type: HAS_SEARCHED, value };
};
